import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
/**
 * 操作日志服务
 */
@Injectable({
  providedIn: 'root'
})
/**
 * 操作日志类
 */
export class LogOpetationService {
  /**
   * 基础平台微服务api
   */
   prefix: string = environment.seekerWebAPI;
  /**
   * 文件处理微服务api
   */
   filefix: string = environment.fileWebAPI;
  /**
  * 任务调度微服务api
  */
   schedulefix: string = environment.scheduleWebApi;
  /**
   * 定义http httpClient
   */
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region 操作日志接口
  /**
   * 查询操作日志所有信息
   * @param param
   * @returns {Observable<any>}
   */
  getLogOperationList(param) {
    const url = this.prefix + 'operationLog/queryPageList';
    return this.http.Post(url, param);
  }

  //#region 操作日志接口
  /**
   * 查询操作日志详细信息
   * @param param
   * @returns {Observable<any>}
   */
  getLogOperationDetails(param) {
    const url = this.prefix + 'operationLog/queryDetails';
    return this.http.Post(url, param);
  }

  /**
   * 查询操作日志所有信息
   * @param param
   * @returns {Observable<any>}
   */
  exportOperationLogList(param) {
    const url = this.prefix + 'operationLog/export';
    let headers = this.http.SetHeader();
    return this.httpClient.post(url, param, { responseType: 'blob', observe: 'response', headers: headers });
  }
  /**
   * demo中自定义导出接口
   * @param param 
   * @returns {Observable<any>}
   */
 /*  export2(param) {
    const url = environment.damWebAPI + 'visitor/baseinfo/customExport';;
    let headers = this.http.SetHeader();
    return this.httpClient.post(url, param, { responseType: 'blob', observe: 'response', headers: headers });
  } */

}
